class userStorage {
    constructor() {}

    setUser(user) {
        localStorage.setItem("user", JSON.stringify(user));
    }

    setToken(token) {
        localStorage.setItem("jwt", token);
    }

    setProfile(profile) {
        localStorage.setItem("profile", JSON.stringify(profile));
    }

    clearData() {
        localStorage.removeItem("user");
        localStorage.removeItem("jwt");
        localStorage.removeItem("profile");
    }

    fetchData() {
        return {
            user: this.getUser(),
            token: localStorage.getItem("jwt"),
            profile: this.getProfile()
        };
    }

    getUser() {
        const value = localStorage.getItem("user");
        if (value) {
            return JSON.parse(value);
        }
        return undefined;
    }

    getProfile() {
        const value = localStorage.getItem("profile");
        if (value) {
            return JSON.parse(value);
        }
        return undefined;
    }

    haveJWT() {
        return localStorage.getItem("jwt") !== undefined;
    }
}

export default new userStorage();
